import { useNavigate } from "react-router-dom";
import { Table } from "src/components/organisms/Table";
import {
  jobNumberColumn,
  tickerColumn,
  recordDateColumn,
  stageColumn,
} from "src/components/organisms/Table/columns";
import {
  NoboEventResult,
  ShareRangeAnalysisEventResult,
  LocationAnalysisEventResult,
} from "src/store/globalSearch/types";

interface Props {
  reports: (
    | NoboEventResult
    | ShareRangeAnalysisEventResult
    | LocationAnalysisEventResult
  )[];
  closeSearchDrawer: () => void;
}

export const SearchReportResults = ({ reports, closeSearchDrawer }: Props) => {
  const navigate = useNavigate();

  if (reports.length === 0) {
    return null;
  }

  const handleReportClick = (
    event:
      | NoboEventResult
      | ShareRangeAnalysisEventResult
      | LocationAnalysisEventResult
  ) => {
    const jobNumber = event.jobNumber || "";
    let route = "";

    if (jobNumber.startsWith("NE")) route = "nobo-events";
    else if (jobNumber.startsWith("SRA")) route = "share-range-analysis-events";
    else if (jobNumber.startsWith("LAE")) route = "location-analysis-events";

    if (route) navigate(`/${route}/${event.id}/details`);
    closeSearchDrawer();
  };

  return (
    <Table
      data={reports}
      columns={[jobNumberColumn, tickerColumn, recordDateColumn, stageColumn]}
      rowOnClick={handleReportClick}
    />
  );
};
